import React from "react";
import { Backdrop, CircularProgress } from "@mui/material";
import { useLoader } from "./LoaderContext";

const GlobalLoader = () => {
  const { loading } = useLoader();

  return (
    <Backdrop
      sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.modal + 1 }}
      open={loading}
    >
      <CircularProgress color="primary" />
    </Backdrop>
  );
};

export default GlobalLoader;
